







































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Temp} from '@/models';

import CrudTempEdit from '@/components/Crud/Temp/Edit.vue';

@Component({
	components: {
		CrudTempEdit,
	}
})
export default class CrudTempEditDialog extends Vue {
	@InOut({ type: Temp  , isVModel: true }) private value!: Temp;
	@InOut({ type: Boolean  , isVModel: false }) private route!: Boolean;

	@Emit()
	private onSubmit(temp: Temp) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
